import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ size = 'medium', fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className={styles.fullScreen}>
        <div className={`${styles.spinner} ${styles[size]}`} />
      </div>
    );
  }

  return <div className={`${styles.spinner} ${styles[size]}`} />;
};

export default LoadingSpinner;

